/**
 * Helpers for leaving a blocked duplicate tab without affecting other tabs.
 *
 * Duplicated Chrome tabs share sessionStorage — never clear it or call server
 * logout when closing a duplicate. Prefer closing the tab; if the browser
 * blocks that, navigate to a minimal page outside the app.
 */

const LEFT_TAB_QUERY = 'leftTab'

const CLOSE_FALLBACK_DELAY_MS = 150

/** True when this tab was sent to the home fallback (?leftTab=1) after close was blocked. */
export function hasLeftTabIntent(): boolean {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get(LEFT_TAB_QUERY) === '1'
}

function navigateToLeftTabHome(): void {
  const url = new URL(window.location.origin)
  url.searchParams.set(LEFT_TAB_QUERY, '1')
  window.location.replace(url.toString())
}

/**
 * Try to close this tab. If the browser refuses (typical for user-opened tabs),
 * navigate to home with ?leftTab=1 (does not clear shared sessionStorage).
 */
export function leaveBlockedTab(): void {
  window.close()
  window.setTimeout(navigateToLeftTabHome, CLOSE_FALLBACK_DELAY_MS)
}
